import './ourexperience.css';

/**
 * Sección "Nosotros" (#aboutus). Las cifras se muestran en <StatsBar> (bajo el hero)
 * desde src/data/credibility.mjs; aquí ya no se repiten.
 */
const Ourexperience = () => {
    return (
        <section className="container" id="aboutus" aria-labelledby="aboutus-title">
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center" data-reveal="up">
                    <h2 id="aboutus-title" className="fables-second-text-color font-35 font-weight-bold my-3 mt-md-5 mb-md-4"><span className="title-underline">Experiencia, Innovación, Calidad y Compromiso</span></h2>
                    <p className="fables-forth-text-color">
                        Desde el desarrollo de software hasta el diseño y la optimización SEO, ofrecemos una experiencia integral.
                        Nos mantenemos a la vanguardia de las últimas tecnologías y tendencias digitales.
                        Nuestro equipo está compuesto por expertos en desarrollo web/móvil, diseño UX/UI, SEO, y más.
                        Nuestra dedicación va más allá de la entrega del proyecto, asegurando un apoyo continuo para el crecimiento sostenible de su presencia digital.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Ourexperience;
